// ---------------------------------------------------------------------------
// Block Definition: table (DocDsl)
//
// Multi-column table with optional header row.  Supports pre-defined row/col
// structure or free-form generation.  LLM generates cell values from source.
// ---------------------------------------------------------------------------

function nullable(type, description, extra = {}) {
  const t = Array.isArray(type) ? type : [type, "null"];
  return { type: t, ...(description ? { description } : {}), ...extra };
}

export const tableDef = {
  type: "table",
  label: "Table",
  description: "Multi-column table with optional header row.",

  crystallizer: {
    extractionPhases: ["llm"],

    buildDataSchema(block, opts) {
      const rows = block.rows || [];
      const cols = block.cols || (rows.length > 0 ? rows[0].length : 0);
      const hasHeader = block.header_row !== false;

      if (rows.length > 0 && cols > 0) {
        const cellProps = {};
        for (let ci = 0; ci < cols; ci++) {
          cellProps[`col_${ci}`] = nullable("string", `Column ${ci + 1} value`);
        }
        const rowProps = { ...cellProps };
        if (hasHeader) rowProps.is_header = { type: "boolean", description: "Is this row a header row?" };
        return {
          type: "object",
          properties: {
            rows: {
              type: "array",
              description: block.prompt || `Fill in each row's ${cols} column values from the source.`,
              minItems: rows.length,
              maxItems: rows.length,
              items: { type: "object", properties: rowProps, required: Object.keys(rowProps), additionalProperties: false }
            }
          },
          required: ["rows"],
          additionalProperties: false
        };
      }

      // Free-form table generation
      const rowProps = {};
      for (let ci = 0; ci < Math.max(cols, 3); ci++) {
        rowProps[`col_${ci}`] = nullable("string", `Column ${ci + 1} value`);
      }
      return {
        type: "object",
        properties: {
          rows: {
            type: "array",
            description: block.prompt
              ? `${block.prompt} Each row has ${cols || 3} columns (col_0, col_1, …).`
              : `Generate table rows with ${cols || 3} columns.`,
            minItems: 1,
            maxItems: 15,
            items: { type: "object", properties: rowProps, required: Object.keys(rowProps), additionalProperties: false }
          }
        },
        required: ["rows"],
        additionalProperties: false
      };
    },

    buildShapeDescription(block) {
      const cols = block.cols || 3;
      return `{ "rows": [["<string>", ...], ...] }  // ${cols}-column table`;
    },

    isBlockLevelTarget(block) {
      return !!(block.rows && block.rows.length > 0);
    },
    skipFromPinSchema() { return false; },
    isCodeDerived() { return false; },
    collectHints() { return []; },
    buildPromptSupplement() { return ""; },
    postProcess(data) { return data; },
  },

  renderer: null, // wired by ui/src/blockRegistryInit.js

  editor: {
    icon: "table",
    category: "data",
    defaultTemplate: { type: "table", cols: 3, header_row: true },
    configFields: [
      { name: "cols", type: "number", label: "Columns", defaultValue: 3 },
      { name: "header_row", type: "boolean", label: "Header row", defaultValue: true },
    ],
  },
};
